import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA-EEYf_lMg0eWbkWN50LmRcuZlK7e5LVo",
  authDomain: "i-cpts-la-providence-79596.firebaseapp.com",
  projectId: "i-cpts-la-providence-79596",
  storageBucket: "i-cpts-la-providence-79596.firebasestorage.app",
  messagingSenderId: "246497724750",
  appId: "1:246497724750:web:9937bdf7c51d53580a761f",
  measurementId: "G-SE326NTF43"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
